import React from "react";
import { philosopher } from "@/lib/fonts";
import HomeHeader from "@/app/components/common/HomeHeader";
import { useAuth } from "@/contexts/AuthContext";
import { useShowInitialLoader } from "@/lib/hooks";
import {
  useGetBannersQuery,
  useGetHomeSubSubCategoriesQuery,
} from "@/lib/api/apiSlice";
import Search from "@/app/components/common/Search";
import BannerCarousel from "@/app/components/home/BannerCarousel";
import CategoryTile from "@/app/components/home/CategoryTile";
import HomeCollections from "@/app/components/home/HomeCollections";

function CategoriesSkeleton() {
  return (
    <section className={`overflow-x-auto px-3 py-2 ${philosopher.className}`}>
      <div className="grid grid-rows-2 grid-flow-col gap-4 w-max">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className="flex w-20 animate-pulse flex-col items-center"
          >
            <div className="aspect-square w-full rounded-xl bg-[#F0E0C7]/60" />
            <div className="mt-2 h-3 w-14 rounded bg-[#F0E0C7]/60" />
          </div>
        ))}
      </div>
    </section>
  );
}

function BannerSkeleton() {
  return (
    <section className="my-6 px-4">
      <div className="aspect-2/1 w-full animate-pulse rounded-2xl bg-[#F0E0C7]/60" />
    </section>
  );
}

export default function HomeScreen() {
  const { data: session, status } = useAuth();

  const { data: subSubCategories, isLoading: isCategoriesLoading } =
    useGetHomeSubSubCategoriesQuery(undefined, {
      skip: status === "loading",
    });

  const { data: banners, isLoading: isBannersLoading } = useGetBannersQuery(
    undefined,
    { skip: status === "loading" },
  );

  const showCategoriesLoader = useShowInitialLoader(
    isCategoriesLoading,
    subSubCategories,
  );
  const showBannersLoader = useShowInitialLoader(isBannersLoading, banners);

  return (
    <div className="mx-auto w-full min-h-screen pb-24">
      <HomeHeader
        primaryText="Welcome,"
        secondaryText={session?.user?.fullName ?? "User"}
        breakLine={true}
      />
      <Search />

      {showCategoriesLoader ? (
        <CategoriesSkeleton />
      ) : (
        <section
          className={`overflow-x-auto px-3 py-2 ${philosopher.className}`}
        >
          <div className="grid grid-rows-2 grid-flow-col gap-4 w-max">
            {(subSubCategories ?? []).map((cat) => (
              <CategoryTile key={cat.id} category={cat} />
            ))}
          </div>
        </section>
      )}

      {showBannersLoader ? (
        <BannerSkeleton />
      ) : (
        <section className="my-6 px-4">
          <BannerCarousel banners={banners ?? []} />
        </section>
      )}

      <HomeCollections />
    </div>
  );
}
